import { WebLayout } from 'components/Layout';
import React, { useEffect } from 'react';

export const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <WebLayout>
      <div className="bg-[#26C4FF] p-6 md:p-12 mt-8 mb-8 md:px-40 text-white text-center">
        <h1 className="text-4xl md:text-7xl font-black">Terms of Service</h1>
      </div>

      <div className="max-w-5xl mx-auto p-6 space-y-10 text-gray-800">
        <section>
          <h2 className="text-2xl font-bold mb-3">1. Introduction</h2>
          <p>
            Welcome to Wire24. These Terms of Service govern your use of our platform for sending
            and receiving money securely. By accessing or using our services, you agree to be bound
            by these terms. If you do not agree, do not use our services.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">2. Eligibility & Account Registration</h2>
          <p>
            To use our services, you must be at least 18 years old and capable of entering into a
            legally binding agreement. You must provide accurate and up-to-date information during
            registration and keep your account credentials secure.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">3. Services & Transactions</h2>
          <p>
            Wire24 provides a platform for users to transfer money internationally. Transactions are
            subject to compliance with financial regulations. Fees and exchange rates apply; please
            review our <span className="text-blue-500">Fee Schedule</span> for details.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">4. Compliance & Security</h2>
          <p>
            Wire24 is committed to ensuring compliance with anti-money laundering (AML) and
            counter-terrorism financing (CTF) laws. Users must not engage in fraudulent, illegal, or
            unauthorized transactions.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">5. Fees, Limits & Refunds</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Transaction fees vary based on amount and destination.</li>
            <li>Limits on transactions may apply depending on regulatory requirements.</li>
            <li>
              Refunds are subject to Wire24's refund policy, and unauthorized transactions should be
              reported immediately.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">6. User Responsibilities</h2>
          <p>
            Users are responsible for maintaining the security of their accounts and must not share
            login credentials. Any suspicious activity should be reported to our support team
            immediately.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">7. Termination & Suspension</h2>
          <p>
            Wire24 reserves the right to suspend or terminate user accounts that violate these
            terms, engage in fraudulent activities, or fail to comply with regulatory requirements.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">8. Dispute Resolution</h2>
          <p>
            Any disputes arising from the use of Wire24 services shall be resolved through
            arbitration or mediation as per our legal jurisdiction.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">9. Limitation of Liability</h2>
          <p>
            Wire24 is not liable for losses resulting from unauthorized transactions, force majeure
            events, or third-party actions. Our liability is limited to the extent permitted by law.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">10. Modifications to Terms</h2>
          <p>
            Wire24 reserves the right to update these Terms of Service. Users will be notified of
            significant changes via email or platform notifications. Continued use of our services
            signifies acceptance of the updated terms.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">11. Contact Information</h2>
          <p>
            If you have any questions regarding these Terms of Service, please contact us at{' '}
            <span className="text-blue-500">support@wire24.co</span>.
          </p>
        </section>
      </div>

      <div className="bg-gray-100 p-6 mt-12 text-center text-gray-600">
        <p>Last updated on 10th February, 2025.</p>
      </div>
    </WebLayout>
  );
};
